import styled from '@emotion/styled'

export const IntegrationsContainer = styled.div`
  max-width: 1060px;
  margin: 0 auto;
`
